<template>
  <div class="oto-comm">
    <div class="base-info">
      <div>
        <slot name="base-info-left" :info="info"></slot>
      </div>
      <el-button type="primary" size="medium" @click="beginCommunicate">
        发起沟通
      </el-button>
    </div>
    <div class="communicates">
      <div
        style="display: flex; justify-content: flex-end; margin-bottom: 16px"
      >
        <el-switch v-model="onlyShow" @change="changeStatus"></el-switch>
        <span style="margin-left: 8px">
          只看{{ $identity.name == "teacher" ? "学员" : "讲师" }}
        </span>
      </div>
      <div class="content">
        <EmptyNew
          v-if="!communicates.length"
          :wrapStyle="{ marginTop: '80px' }"
          title="暂无沟通记录"
        ></EmptyNew>
        <div
          class="content-item"
          :class="{
            teacher: !isSelf(item.belong),
            student: isSelf(item.belong),
          }"
          :style="{ textAlign: !isSelf(item.belong) ? 'left' : 'right' }"
          v-for="item in communicates"
          :key="item.id"
        >
          <template v-if="!isSelf(item.belong)">
            <div class="teacher-baseInfo">
              <img
                :src="
                  $identity.name == 'teacher'
                    ? info.user_avatar
                    : info.teacher_avatar
                "
                alt=""
              />
              <div class="base">
                <p>
                  {{
                    $identity.name == "teacher"
                      ? info.user_name
                      : info.teacher_name
                  }}
                </p>
                <p>{{ item.created_at | tsFormatLong }}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="student-baseInfo">
              <div class="base">
                <p>我</p>
                <p>{{ item.created_at | tsFormatLong }}</p>
              </div>
              <img
                :src="
                  $identity.name == 'teacher'
                    ? info.teacher_avatar
                    : info.user_avatar
                "
                alt=""
              />
            </div>
          </template>
          <div class="chat-content">
            <div class="text" v-if="item.chat_content">
              {{ item.chat_content }}
            </div>
            <div
              class="file"
              v-if="item.file.length > 0"
              :class="{
                teacher: !isSelf(item.belong),
                student: isSelf(item.belong),
              }"
            >
              <div
                v-for="(itemChild, index) in item.file"
                :key="index"
                class="file-item"
              >
                <div class="file-name">
                  <img src="@/assets/images/file.png" />
                  <p>{{ itemChild.file_name }}</p>
                </div>
                <div class="operate" @click="onDownload(itemChild.file_url)">
                  <img src="@/assets/images/download.png" />
                  <span>下载</span>
                </div>
              </div>
            </div>
            <div class="imgs" v-if="item.img_url.length > 0">
              <img
                :src="itemChild.file_url"
                alt=""
                v-for="(itemChild, index) in item.img_url"
                :key="index"
                @click="previewImg(itemChild.file_url)"
              />
            </div>
            <div
              v-if="isSelf(item.belong)"
              class="on-delete"
              @click="deleteCommunicate(item.id)"
            >
              删除
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-communication"
      title="发起沟通"
      :visible.sync="showDialog"
      width="800px"
    >
      <div>
        <el-input
          type="textarea"
          autosize
          placeholder="请输入要与老师沟通的问题，如需要老师待会上课讲的问题。最多500字。"
          v-model="form.content"
          :maxlength="500"
        ></el-input>
      </div>
      <div class="upload">
        <label>上传文件：</label>
        <div>
          <div class="upload-file">
            <el-upload
              ref="uploadFile"
              :action="uploadFileUrl"
              :on-success="uploadFileSuccess"
              :headers="headers"
            >
              <el-button size="small" type="default" icon="el-icon-plus">
                选择文件
              </el-button>
            </el-upload>
            <div class="clear">
              <div
                class="item f-left"
                v-for="(file, index) in allUploadList"
                :key="file.url"
              >
                <a :href="file.url" target="_blank">
                  <img src="@/assets/images/file@2x.png" style="width: 12px" />
                  <span>{{ file.name }}</span>
                </a>
                <i
                  class="el-icon-error"
                  @click.stop="allUploadList.splice(index, 1)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitCommucate">发布</el-button>
      </div>
    </el-dialog>
    <ImageViewer
      :images="images"
      :isShow.sync="isShowImageViewer"
    ></ImageViewer>
  </div>
</template>
<script>
const buildConfig = require("@/build/" + process.env.BUILD_ENV + ".js");
import ImageViewer from "@/components/ImageViewer.vue";
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "PeriodsMemberOtoCommunicationComponents",
  components: {
    ImageViewer,
    EmptyNew,
  },
  props: {
    // 请求数据url
    requestUrl: {
      required: true,
      type: String,
    },
    // 课次id
    timesId: {},
    // 学员id
    userId: {},
    //发布url
    publishUrl: {
      required: true,
      type: String,
    },
    //删除url
    deleteUrl: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      onlyShow: false,
      info: {},
      communicates: [],
      showDialog: false,
      form: {
        content: "",
        fileList: [],
        imageList: [],
      },
      uploadUrl: "",
      uploadFileUrl: "",
      headers: {
        Authorization:
          "Bearer " +
          (this.$identity.name == "teacher"
            ? localStorage.teacherToken
            : localStorage.studentToken),
      },
      weeks: {
        0: "星期日",
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六",
      },
      hasInit: false,
      images: [],
      isShowImageViewer: false,
      allUploadList: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user_info;
    },
    innerTimesId() {
      return this.timesId || this.$route.query.id;
    },
    innerUserId() {
      return this.userId || this.user.id;
    },
  },
  async created() {
    if (this.$identity.name == "teacher") {
      this.uploadUrl = buildConfig.BASE_URL + "/api/lector/public/img";
      this.uploadFileUrl = buildConfig.BASE_URL + "/api/lector/public/file";
    } else if (this.$identity.name == "student") {
      this.uploadUrl = buildConfig.BASE_URL + "/api/app/public/img";
      this.uploadFileUrl = buildConfig.BASE_URL + "/api/app/public/file";
    }
    await this.getData();
    setTimeout(() => {
      triggerLoaded(this);
    }, 0);
  },
  watch: {
    user: async function () {
      if (this.hasInit) {
        return;
      }
      await this.getData();
    },
  },
  methods: {
    previewImg(url) {
      this.images = [];
      this.images.push(url);
      this.isShowImageViewer = true;
    },
    // 是否为自己 belong 0-学员 1-讲师
    isSelf(belong) {
      if (this.$identity.name == "teacher") {
        return belong == 1;
      }
      return belong == 0;
    },
    changeStatus(value) {
      console.log(value);
      this.getData();
    },
    async getData() {
      if (!this.innerUserId) {
        return;
      }
      this.hasInit = true;
      let params = {
        id: this.innerTimesId,
        user_id: this.innerUserId,
      };
      if (this.onlyShow) {
        params.belong = this.$identity.name == "teacher" ? 0 : 1;
      }
      let data = await this.$http.get(
        `${this.requestUrl}${this.innerTimesId}`,
        params,
      );
      this.info = data.base_info;
      this.communicates = data.communicate;
    },
    beginCommunicate() {
      this.showDialog = true;
      this.form.content = "";
      this.form.fileList = [];
      this.form.imageList = [];
      this.allUploadList = [];
    },
    async submitCommucate() {
      if (
        !this.form.content &&
        !this.form.imageList.length &&
        !this.form.fileList.length
      ) {
        this.$info("请输入要与老师沟通的问题");
        return;
      }
      let data = {
        id: this.innerTimesId,
        user_id: this.innerUserId,
        chat_content: this.form.content,
      };

      let images = [];
      this.form.imageList.forEach(file => {
        let f = {
          file_name: file.name,
          file_url: file.url,
        };
        images.push(f);
      });
      data.img_url = JSON.stringify(images);

      let files = [];
      this.form.fileList.forEach(file => {
        let f = {
          file_name: file.name,
          file_url: file.url,
        };
        files.push(f);
      });
      data.file = JSON.stringify(files);

      await this.$http.post(`${this.publishUrl}${this.innerTimesId}`, data);
      await this.$success("发布成功");
      this.showDialog = false;
      await this.getData();
    },
    async uploadSuccess(response) {
      this.$refs.upload.clearFiles();
      if (response.code != 200) {
        await this.$error(response.msg);
      } else {
        this.form.imageList.push({
          name: response.data.originalName,
          url: response.data.path,
        });
      }
    },
    async uploadFileSuccess(response) {
      this.$refs.uploadFile.clearFiles();
      if (response.code != 200) {
        await this.$error(response.msg);
      } else if (response.data.type == "file") {
        this.form.fileList.push({
          name: response.data.originalName,
          url: response.data.path,
        });
        this.allUploadList.push({
          name: response.data.originalName,
          url: response.data.path,
        });
      } else if (response.data.type == "image") {
        this.form.imageList.push({
          name: response.data.originalName,
          url: response.data.path,
        });
        this.allUploadList.push({
          name: response.data.originalName,
          url: response.data.path,
        });
      }
    },
    async changeType() {
      await this.getData();
    },
    async deleteCommunicate(id) {
      if (this.$identity.name == "teacher") {
        await this.$promiseConfirm(
          "删除后学员会看不到你发的内容，确定删除么？",
        );
      } else {
        await this.$promiseConfirm("删除后老师会看不到你的问题，确定删除么？");
      }
      await this.$http.delete(this.deleteUrl + id, {
        id: id,
      });
      await this.$success("删除成功");
      await this.getData();
    },
    beforeUpload(file) {
      let type = file.type.toLowerCase();
      if (type.indexOf("image/") < 0) {
        this.$message.info("请上传图片");
        return false;
      }
    },
    onDownload(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./css/member-oto.scss";
</style>
